const $accessories = $('.related-accessories');

if ($accessories.length) {
  const self = {};

  /** Initialise the module. */
  self.initialise = function initialise() {
    const $carousel = $('.carousel', $accessories);

    $carousel.slick({
      arrows: true,
      dots: false,
      draggable: true,
      infinite: true,
      /* eslint-disable max-len */
      nextArrow: '<button class="slick-next" type="button"><span class="sr-only">Previous</span></i></button>',
      prevArrow: '<button class="slick-prev" type="button"><span class="sr-only">Next</span></button>',
      /* eslint-enable max-len */
      slidesToShow: 4,
      slidesToScroll: 1,
      swipe: true,

      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      }, {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      }],
    });
  };

  self.initialise();
}
